<template>
  <div class='full-page fist'>
    <div class='box'>
      <img src='../assets/img/freeze.svg' class='freeze'>
      <div class='number-info'>
        <h1>Total de  <br/> geladeiras</h1>
        <div class='number'> <div class='count'> {{ !loading ? numRefrigerators : '...' }} </div> </div>
      </div>
      <div class='targe color1'></div>
    </div>

    <div class='box-medium'>
      <img src='../assets/img/freeze.svg' class='freeze'>
      <div class='number-info-medium'>
        <div class='number'> <div class='count'> {{ !loading ? numRefrigeratorsAvailables : '...' }} </div> </div>
        <h1>geladeiras <br/>  disponíveis</h1>
      </div>
      <div class='targe color2'></div>
    </div>

    <div class='box-medium' style='left: 0.8vw'>
      <div class='targe color3'></div>
      <img src='../assets/img/freeze.svg' class='freeze'>
      <div class='number-info-medium'>
        <div class='number'> <div class='count'> {{ !loading ? numCheckIn : '...' }} </div> </div>
        <h1>geladeiras  <br/> confirmadas</h1>
      </div>
      <div class='targe color3'></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'first-page',

  props: ['numRefrigerators', 'numRefrigeratorsAvailables', 'numCheckIn', 'loading'],

  mounted () {
    $('.targe').css('width', 'calc(100% - 4vw)')
  }
}
</script>

<style scoped>
.color1, .color2, .color3 {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/FirstPage.vue